// store/index.js
import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./auth";
import cartReducer from "./cart";
import { createTestsReducer } from "./tests"; // will build the reducer after fetching DTCPaging

export const createAppStore = async (labid) => {
  const testsReducer = await createTestsReducer(labid);

  const store = configureStore({
    reducer: {
      tests: testsReducer,
      auth: authReducer,
      cart: cartReducer,
    },
  });

  return store;
};

